import NextLink from "next/link";
import { Text, Box, IconFa, Link } from "@cruk/cruk-react-components";
import { faSterlingSign } from "@fortawesome/free-solid-svg-icons";

import { useTracking } from "@fwa/src/hooks/useTracking";
import { isPast } from "@fwa/src/utils/timeUtils";
import { userNameForPage } from "@fwa/src/utils/pageUtils";

import { MemberFundraisingPage } from "@fwa/src/components/MemberFundraisingPage";

import styles from "@fwa/src/components/MemberFundraisingPageDonate/styles.module.css";

import { type FundraisingPageType } from "@fwa/src/types";

export const MemberFundraisingPageDonate = ({
  fundraisingPage,
  isLeader = false,
}: {
  fundraisingPage: FundraisingPageType;
  isLeader?: boolean;
}) => {
  const name = userNameForPage(fundraisingPage);
  const { trackEventGtm } = useTracking();
  const { closeDate } = fundraisingPage;
  const hasPageClosed = closeDate && isPast(new Date(closeDate));

  if (!fundraisingPage) return null;

  return (
    <MemberFundraisingPage
      fundraisingPage={fundraisingPage}
      isLeader={isLeader}
      data-component="member-fundraising-page-overview"
    >
      <Box paddingTop="xs" margin="none">
        {hasPageClosed ? (
          <div className={styles["responsive-align"]}>
            <Text
              style={{ lineHeight: "3rem" }}
              textWeight="heavy"
              textAlign="center"
            >
              Page Closed
            </Text>
          </div>
        ) : (
          <div className={styles["responsive-align"]}>
            <NextLink
              href={`/donate/${fundraisingPage?.uniqueId}/details`}
              aria-label={`Donate to ${name}`}
              onClick={() => {
                trackEventGtm({ event: "donate_cta", cta: "member" });
              }}
              data-cta-type="donate"
            >
              <Link appearance="secondary" as="span">
                <Box as="span" marginRight="xxs">
                  <IconFa faIcon={faSterlingSign} />
                </Box>
                Donate
              </Link>
            </NextLink>
          </div>
        )}
      </Box>
    </MemberFundraisingPage>
  );
};

export default MemberFundraisingPageDonate;
